import { render, staticRenderFns } from "./UploadPublicWeddingEventImages.vue?vue&type=template&id=6435b5d9&scoped=true"
import script from "./UploadPublicWeddingEventImages.vue?vue&type=script&lang=ts"
export * from "./UploadPublicWeddingEventImages.vue?vue&type=script&lang=ts"
import style0 from "./UploadPublicWeddingEventImages.vue?vue&type=style&index=0&id=6435b5d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6435b5d9",
  null
  
)

export default component.exports